import colors from 'Assets/colors'
import styled from 'styled-components'

export const AcceptButtonContanier = styled.button`
  background: ${colors.cart};
  border-radius: 0.5rem;
  cursor: pointer;
  width: 45px;
  height: 45px;

  &:hover {
    opacity: 0.8;
    transform: translateY(-1px);
    box-shadow: 0 3px 5px rgba(51, 51, 51, 0.2);
  }

  &:active {
    transform: translate(-1px);
    box-shadow: 0 1px 3px rgba(51, 51, 51, 0.4);
  }
`
